import { freightTypeEnum } from '../../../hooks/freights/useConfigureFreight';
import {
  CartStatus,
  DeliveryStatus,
  ReceiptStatus,
} from '../../../types/drawer.types';
import { DriverLicense } from '../driver/types';
import { Vehicle } from '../tables/types';

export enum ImportFile {
  IMPORT_FILE_SUCCESS = 'IMPORT_FILE_SUCCESS',
  IMPORT_FILE_FAILURE = 'IMPORT_FILE_FAILURE',
  CALCULATE_FREIGHT_SUCCESS = 'CALCULATE_FREIGHT_SUCCESS',
  CALCULATE_FREIGHT_FAILURE = 'CALCULATE_FREIGHT_FAILURE',
  SHOW_FREIGHT = 'SHOW_FREIGHT',
  UPDATE_DELIVERY = 'UPDATE_DELIVERY',
  GET_DELIVERIES = 'GET_DELIVERIES',
}

export enum Rating {
  GET_RATING_DRIVER = 'GET_RATING_DRIVER',
}

export interface InitialImportFile extends RatingDriver {
  totalValue: any;
  // totalValue: number;
  message: string;
  type: string;
  freights: {
    page: number;
    rows: Freights[];
    totalRecords: number;
  };
  deliveries: Deliveries[];
  freightCost: number;
  totalKilometers: number;
  priceWithFee: number;
  vehicleTypeId: string;
  vehicleType: string;
  numberOfHelpers: number;
  totalWeight: number;
  freight: {
    totalValue: number;
    freightId: string;
    freightRequest: any;
    freightCost: number;
    totalKilometers: number;
    numberOfHelpers: number;
    deliveryLimitDate: string;
    freightStatus: string;
    vehicleTypePrice: number;
    totalWeight: number;
    pickUpDate: string;
    acceptDate: string | null;
    createdAt: string;
    updatedAt: string;
    distributor: Distributors;
    vehicleType?: VehicleType;
    vehicle?: Vehicle;
    freightType: freightTypeEnum;
    driver: {
      driverId: string;
      username: string;
      email: string;
      cpf: string;
      rg: string;
      phoneNumber: string;
      status: string;
      createdAt: string;
      updatedAt: string;
    };
    deliveries: Deliveries[];
  };
}

export interface RatingDriver {
  ratingDriver: {
    rating: number;
    description: string;
  };
}

export interface Freights {
  freightId: string;
  price: number;
  numberOfHelpers: number;
  deliveryLimitDate: string;
  driver: string;
  admin: string;
  createdAt: string;
  updatedAt: string;
  freightCost: number;
  totalKilometers: number;
  freightStatus: string;
  vehicleTypePrice: number;
  totalWeight: number;
  pickUpDate: string;
  acceptDate: string;
  vehicleType: VehicleType;
  vehicle: Vehicle;
  freightType: freightTypeEnum;
  distributor: Distributors;
  deliveries: Deliveries[];
}
export interface VehicleType {
  vehicleTypeId: string;
  vehicleType: string;
  payloadCapacity: string;
  packLoadWeight: string;
  costPerAssistant: string;
  driverCost: string;
  costPerKilometer: string;
  costPerTon: string;
  costPerCubicMeter: string;
  costPerOrder: string;
  createdAt: string;
  updatedAt: string;
}
export interface Distributors {
  distributorId: string;
  name: string;
  cnpj: string;
  stateRegistration: string;
  streetAddress: string;
  streetNumber: string;
  zipCode: string;
  state: string;
  city: string;
  neighborhood: string;
  latitude: string;
  longitude: string;
  fee: number;
  feeType: string;
  status: string;
  createdAt: string;
  updatedAt: string;
}
export interface Driver {
  birthDate: Date;
  cpf: string;
  createdAt: string;
  deletedAt: string;
  driverId: string;
  email: string;
  phoneNumber: string;
  pushNotificationToken: string;
  resetPasswordSentAt: string;
  resetPasswordToken: string;
  rg: number;
  selfie: string;
  status: string;
  driverLicense?: DriverLicense;
  updatedAt: string;
  username: string;
  type: DriverTypeEnum;
}

export enum DriverTypeEnum {
  PRIVATE = 'Privado',
  AUTONOMOUS = 'Autonomo',
}

export interface Cart {
  cartStatus: CartStatus;
  cartId: string;
  deliveries: Deliveries[];
  receipt: Receipt;
}

export interface Receipt {
  receiptId: string;
  nf: string;
  createdAt: Date;
  status: ReceiptStatus;
  updatedAt: Date;
  deletedAt: null;
  images: Image[];
}

export interface Image {
  receiptImageId: string;
  urlSmall: string;
  urlMain: string;
  approvedOn: Date;
  rejectedOn: Date;
  createdAt: Date;
  updatedAt: Date;
}

export interface Deliveries {
  freight: Freights;
  nf: string;
  carts: Cart[];
  receiptUploadedAt: string;
  deliveryId: string;
  deliveryCode?: null;
  sequential: number;
  phone?: null;
  fantasyName?: null;
  corporateName: string;
  address: string;
  cep: string;
  latitude: string;
  longitude: string;
  loadNumber: string;
  createdAt: string;
  updatedAt: string;
  status?: DeliveryStatus;
  orders?: Orders[];
}
export interface Orders {
  orderId?: string;
  orderCode?: string;
  price?: string;
  receipt?: string;
  receiptUploadedAt?: string;
  numberOfOrders?: number;
  weight?: number;
  createdAt?: string;
  updatedAt?: string;
  report?: reportProblem;
  description?: string;
}

export interface FreightRequest {
  freightRequestId: string;
  extraCartIds: string[];
  originLatitude: number;
  originLongitude: number;
  totalWeight: number;
  totalKilometers: number;
  totalDeliveries: number;
  freightCost: number;
  freightType: string;
  totalValue: number;
  numberOfHelpers: number;
  waypoints: string[];
  pickUpDate: string;
  pickUpTime: string;
  deliveryLimitDate: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: string;
  deliveryRequests: DeliveryRequest[];
  freight: Freights;
  vehicleType: string;
  driver: Driver;
  vehicle: Vehicle;
}

export interface DeliveryRequest {
  freightRequest: FreightRequest[];
  deliveryRequestId: string;
  address: string;
  latitude: number;
  longitude: number;
  cep: string;
  totalWeight: number;
  nf: string;
  totalValue: number;
  corporateName: string;
  loadNumber: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: null;
}

export enum reportProblem {
  ESTABELECIMENTO_FECHADO = 'Estabelecimento fechado',
  DESACORDO_PRECO = 'Desacordo preço',
  DESACORDO_QUANTIDADE = 'Desacordo quantidade',
  NAO_FEZ_PEDIDO = 'Não fez pedido',
  PROPRIETARIO_AUSENTE = 'Proprietário ausente',
  ATRASO_NA_ENTRETA = 'Atraso na entrega',
  AVARIA_NO_TRANSPORTE = 'Avaria no transporte',
  PEDIDO_EM_DUPLICIDADE = 'Pedido em duplicidade',
  MERC_PROX_VALIDADE = 'Merc. Próx. Validadde',
  AVARIA_PONTO_VENDA = 'Avaria no ponto de venda',
  AJUSTE_FISCAL = 'Ajuste fiscal',
  ERRO_SISTEMA = 'Erro no sistema',
  DESACORDO_PRAZO = 'Desacordo prazo',
  DEV_PORT_FALTA_MERC_CARRO = 'DEV. Por falta Merc. No carro',
  CLIENTE_SE_RECUSOU_RECEBER = 'Cliente recusou a receber',
  ERRO_DIGITACAO = 'Erro de digitação',
  ERRO_FABRIC_PRODUTO = 'Erro de Fabric. do produto',
  INDENIZACAO_PENDENTE = 'Indenização pendente',
  OUTROS = 'Outros',
}
